export default __webpack_public_path__ + "images/4d248b34cae59ca3f7cfad6be1472d13.png";